export const localeType = Object.freeze({
  EN: 'en',
  RU: 'ru',
  UK: 'ru', // Ukrainian
  BE: 'ru', // Belarusian
  KK: 'ru', // Kazakh
  DEFAULT: 'en'
});

export enum LocaleTypes {
  EN = 'en',
  RU = 'ru',
  UK = 'ru', // Ukrainian
  BE = 'ru', // Belarusian
  KK = 'ru', // Kazakh
  DEFAULT = 'en'
}

export enum BaseTemplateComponents {
  UPPER_BANNER = 'upperBanner',
  UPPER_BANNER2 = 'upperBanner2',
  VACANCIES = 'vacancies',
  SELF_REALIZATION_CONDITIONS = 'selfRealizationConditions',
  OFFICE_GALLERY = 'officeGallery',
  COMFORT_CONDITIONS = 'comfortConditions',
  VACANCY_LIST = 'vacancy_list'
}

export enum LightYaTemplateComponents {
  UPPER_BANNER = 'upperBanner',
  VACANCIES = 'vacancies',
  SELF_REALIZATION_CONDITIONS = 'selfRealizationConditions',
  OFFICE_GALLERY = 'officeGallery',
  COMFORT_CONDITIONS = 'comfortConditions',
  BLOG = 'blog'
}

export enum CompanyFetchStatus {
  AUTH = 'auth',
  NOT_AUTH = 'not_auth',
  FAILURE = 'FAILURE'
}

export enum VacancyFetchStatus {
  SUCCESS = 'success',
  FAILURE = 'failure'
}

export enum SaveChangesStatus {
  READY_TO_SAVE = 'ready_to_save',
  SAVING = 'saving',
  SAVED = 'saved'
}

export enum PublishTemplateStatus {
  READY_TO_PUBLISH = 'ready_to_publication',
  PUBLICATION = 'publication',
  PUBLISHED = 'published'
}
